<template>
  <div id="hockey" >
    <div class="pointOut" >必填</div>
    <van-cell-group>
      <van-field
        v-model="info.guardian"
        label="监护人"
        placeholder="请输入监护人姓名"
        error-message-align="right"
        :error-message="validator.ErrMsg.guardian">
      </van-field>
      <van-radio-group
        v-model="info.guardianCertType">
        <van-cell-group>
          <van-cell title="证件类型" clickable>
            <van-radio checked-color="#185494" name="身份证" >身份证</van-radio>
            <van-radio checked-color="#185494" name="护照" >护照</van-radio>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-field
        v-model="info.guardianCertNum"
        label="证件号"
        placeholder="请输入证件号"
        error-message-align="right"
        :error-message="validator.ErrMsg.guardianCertNum">
      </van-field>
      <van-field
        v-model="info.guardianMobile"
        type="text" label="电话"
        placeholder="请输入监护人电话"
        error-message-align="right"
        :error-message="validator.ErrMsg.guardianMobile">
      </van-field>
      <van-field
        v-model="info.guardianRelation"
        type="text"
        label="与队员关系"
        placeholder="请输入监护关系"
        error-message-align="right"
        :error-message="validator.ErrMsg.guardianRelation" >
      </van-field>
      <van-field
        v-model="info.email"
        type="text" label="电子邮箱"
        placeholder="请输入电子邮箱"
        error-message-align="right"
        :error-message="validator.ErrMsg.email">
      </van-field>
      <div class="pointOut">选填</div>
      <van-field
        v-model="info.guardianAddress"
        type="text"
        label="工作单位"
        placeholder="单位">
      </van-field>
    </van-cell-group>

    <van-button class="btn" v-if="!isRead || isAppend" size="large" @click="submitRegistInfo()" :disabled="loading">完成</van-button>
    <van-button class="btn" v-if="isRead && !isAppend" size="large" @click="updatePlayer()" :disabled="loading">保存</van-button>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import { getValidMembership, documentVerification } from '@/utils'
import Validator from '@/libs/validator'
import { registPlayer, getMyPlayer, updatePlayer, getSourceList } from '@/api/info'
import { checkPassport } from '@/libs/passport'
import { Field, Toast } from 'vant'
import { setRegisterInfo, getRegisterInfo, removeMemberType, removeRegisterInfo, getMemberType } from '@/libs/cookie-storage'

Vue.use(Field)

const rulesField = ['guardian', 'guardianCertType', 'guardianCertNum', 'guardianMobile', 'guardianRelation', 'guardianEmail']

export default {
  name: '',
  data() {
    return {
      info: {
        guardian: '',
        guardianCertType: ''
      },
      isRead: false,
      isAppend: false,
      rules: {
        guardian: [{ required: true, message: '必填消息' }],
        guardianMobile: [{ required: true, message: '必填消息' }],
        guardianRelation: [{ required: true, message: '必填消息' }],
        email: [{ required: true, message: '必填消息' }],
        guardianCertType: [{ required: true, message: '必填消息' }],
        guardianCertNum: [
          { required: true, message: '必填消息' },
          { validator: (rule, value, callBack) => {
              const idVerify = documentVerification(value)
              if (this.info.guardianCertType === '身份证' && idVerify.pass) {
                callBack()
              } else if (this.info.guardianCertType === '护照') {
                callBack()
              } else {
                callBack(idVerify.msg)
              }
            }
          }
        ]
      },
      reset: '',
      loading: false
    }
  },
  created() {
    checkPassport()
    this.sourceList = getSourceList()
    const memberType = getMemberType()
    if (!memberType) return
    this.type = memberType.type
    const regInfo = getRegisterInfo()
    if (regInfo) {
      const guardians = regInfo.guardians
      let obj = {
        guardianId: '',
        guardian: '',
        guardianCertType: '',
        guardianCertNum: '',
        guardianMobile: '',
        guardianRelation: '',
        // guardianEmail: guardians[0].email,
        guardianAddress: ''
      }
      if (guardians && guardians.length>0) {
        obj = {
          guardianId: guardians[0].id,
          guardian: guardians[0].name,
          guardianCertType: guardians[0].certificateType,
          guardianCertNum: guardians[0].certificateNum,
          guardianMobile: guardians[0].mobile,
          guardianRelation: guardians[0].relation,
          // guardianEmail: guardians[0].email,
          guardianAddress: guardians[0].address
        }
      }
      this.info = Object.assign(this.info, regInfo, obj)
    }
    if (memberType.status === 2) {
      this.isRead = true
      this.getMyPlayer()
    }
    this.validMemberShip = getValidMembership()
    if(this.validMemberShip.membership && this.validMemberShip.membership.length > 0) {
      const obj = _.find(this.validMemberShip.membership, function (item) {
        return item.membershipTypeId === memberType.membershipTypeId
      })
      this.isAppend = !obj
      if (this.isAppend) {
        this.isRead = true
      }
    }
    this.validator = new Validator({
      rules: this.rules,
      data: this.info
    })
    this.reset = this.$route.query.reset
  },
  mounted() {},
  methods: {
    routerPush() {
//      this.$router.push('status')
    },
    submitRegistInfo() {
      this.loading = true
      this.validator.validate(rulesField).then(() => {
        const regInfo = Object.assign(getRegisterInfo(), this.info)
        setRegisterInfo(regInfo)
        let param = {
          profile: regInfo.profile,
          trueName: regInfo.trueName,
          gender: regInfo.gender,
          nationality: regInfo.nationality,
          birthday: moment(regInfo.birthday).format('YYYY-MM-DDTHH:mm:ss+0800'),
          certificateType: regInfo.certificateType==='身份证'? 1 : 2,
          certificateNum: regInfo.certificateNum,
          certificateFrontImg: regInfo.certificateFrontImg,
          certificateBackImg: regInfo.certificateBackImg,
          category: regInfo.category,
          schoolId: regInfo.school.id,
          enterSchoolYear: regInfo.enterSchoolYear,
          organizationId: regInfo.organizationId || regInfo.organization.id,
          studentCardImg: regInfo.studentCardImg,
          area: '北京-长期',
          high: regInfo.high,
          weight: regInfo.weight,
          stickHand: regInfo.stickHand,
          educationSummary: regInfo.educationSummary,
          team: regInfo.team,
          position: regInfo.position,
          jerseyNo: regInfo.jerseyNo,
          coachId: regInfo.coachId || (regInfo.coach && regInfo.coach.id),
          declaredHistoryOrgnizations: regInfo.declaredHistoryOrgnizations,
          declaredHistoryTeams: regInfo.declaredHistoryTeams,
          athletePerformance: regInfo.athletePerformance,
          guardian: regInfo.guardian,
          guardianCertificateType: regInfo.guardianCertType==='身份证'? 1 : 2,
          guardianCertificateNum: regInfo.guardianCertNum,
          guardianMobile: regInfo.guardianMobile,
          guardianRelation: regInfo.guardianRelation,
          email: regInfo.email,
          guardianAddress: regInfo.guardianAddress
        }
        if (regInfo.source === this.sourceList[3]) {
          param.source = regInfo.otherSource
        } else {
          param.source = regInfo.source
        }
        if (regInfo.id) {
          param.id = regInfo.id
          updatePlayer(param).then((res) => {
            if (res) {
              Toast('完善信息成功')
              // removeMemberType()
              removeRegisterInfo()
              this.$router.push('review')
            }
            this.loading = false
          }, (reject) => {
            Toast('请填写必要的信息')
            this.loading = false
          })
        } else {
          registPlayer(param).then((res) => {
            if (res) {
              Toast('完善信息成功')
              // removeMemberType()
              removeRegisterInfo()
              this.$router.push('review')
            }
            this.loading = false
          }, (reject) => {
            Toast('请填写必要的信息')
            this.loading = false
          })
        }
      }, () => {
        Toast('请填写必要的信息')
        this.loading = false
      })
    },
    getMyPlayer() {
      getMyPlayer().then(response => {
        const data = response.data
        if (data) {
          const guardians = data.player.guardians
          let obj = {
            guardianId: '',
            guardian: '',
            guardianCertType: '',
            guardianCertNum: '',
            guardianMobile: '',
            guardianRelation: '',
            // guardianEmail: guardians[0].email,
            guardianAddress: ''
          }
          if (guardians && guardians.length > 0) {
            obj = {
              guardianId: guardians[0].id,
              guardian: guardians[0].name,
              guardianCertType: guardians[0].certificateType===1?'身份证':'护照',
              guardianCertNum: guardians[0].certificateNum,
              guardianMobile: guardians[0].mobile,
              guardianRelation: guardians[0].relation,
              // guardianEmail: guardians[0].email,
              guardianAddress: guardians[0].address
            }
          }
          if (data.player.user) {
            delete data.player.user.id
          }
          this.info = Object.assign(data.player, data.player.user, obj)
          this.validator = new Validator({
            rules: this.rules,
            data: this.info
          })
        }
      })
    },
    updatePlayer() {
      this.loading = true
      this.validator.validate(rulesField).then(() => {
        const guardians = [
          {
            id: this.info.guardianId,
            name: this.info.guardian,
            certificateType: this.info.guardianCertType==='身份证'? 1 : 2,
            certificateNum: this.info.guardianCertNum,
            mobile: this.info.guardianMobile,
            relation: this.info.guardianRelation,
            // email: this.info.email,
            address: this.info.guardianAddress
          }
        ]
        const params = {
          id: this.info.id,
          email: this.info.email,
          guardians: JSON.stringify(guardians)
        }
        updatePlayer(params).then(response => {
          const data = response.data
          if (data) {
            Toast('保存成功')
            if (this.reset==1) {
              this.$router.push({ path: 'review', query: {reset: 2} })
            } else {
              this.$router.push('ucenter')
            }
          }
          this.loading = false
        })

      }, (rej) => {
        Toast('请填写必要的信息')
        this.loading = false
      })
    }
  },
  computed: {}
}
</script>
<style>

  #hockey .pointOut {
    padding: 0 15px;
    height: 40px;
    background-color: rgba(248,248,248,1);
    font-weight:400;
    color:rgba(129,129,129,1);
    line-height: 40px;
  }

  #hockey .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  #hockey .van-hairline--top-bottom::after {
    border-width: 0;
  }

  #hockey .van-cell {
    font-size: 16px;
    padding: 20px 15px;
    border-bottom: 1px solid #F2F2F2;
  }

  #hockey .btn {
    height:60px;
    background: #185494;
    border-radius:2px;
    border: none;
    margin-top: 132px;
    font-weight:400;
    color: white;
    font-size:20px;
  }
  #hockey .van-cell--clickable .van-cell__value .van-radio {
    float: right;
    padding: 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/contact-hockey.vue